import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {

        // 添加事件
        AddOption() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            params = Object.assign({}, params, this.form);
            $http.post('api/Option/AddOption', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.$emit('reloadList')
                    this.close()
                });
            });
        },
        // 获取单条
        GetById(Id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            this.loading = true;
            $http.get("api/Option/GetById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form.ModuleId = Data.ModuleId
                    this.form.OptionTitle = Data.OptionTitle
                    this.form.List = []
                    let len = Data.OptionList.length
                    for (let i = 0; i < len; i++) {
                        this.form.List.push({
                            "Name": Data.OptionList[i].OptionName
                        })
                    }
                    for (let i = 1; i < len; i++) {
                        this.isDelBtnShow.push(true); //删除按钮
                        this.isAddBtnShow.unshift(false); //新增按钮
                    }
                });
            });
        },
        //修改提交事件POST /api/Option/ModifyOption
        ModifyOption() {
            var params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            params = Object.assign({}, params, this.form);
            $http.post('api/Option/ModifyOption', params).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.$emit('reloadList')
                    this.close()
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Network/checkList/modalDialog/services.js